import { FCX, ID } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { ReactNode, useMemo } from "react";
import HorizontalBar from "@components/HorizontalBarChart/HorizontalBar";

export type HorizontalBarChartItem = {
    id: ID;
    numValue: number;
    value: ReactNode;
    label: ReactNode;
    isHidden?: boolean;
};

const HorizontalBarChart: FCX<{
    data: HorizontalBarChartItem[];
    color: string;
}> = ({
    data,
    color,
    className,
    testId,
    ...props
}) => {
    const maxValue = useMemo(
        () => Math.max(...data.map(item => item.numValue)),
        [data]
    );

    return (
        <div
            className={cn("HorizontalBarChart", className)}
            data-testid={testId}
            {...props}
        >
            <div className="HorizontalBarChart__labels">
                {data.map((item, index) => (
                    <div
                        key={item.id}
                        className={cn(
                            "HorizontalBarChart__row",
                            item.isHidden && "is-hidden",
                            'appears-top',
                            `del-${index}`,
                            'fast',
                        )}
                    >
                        <div
                            className="HorizontalBarChart__label"
                            data-testid={`textHorizontalBarChartLabel${index}`}
                        >
                            {item.label}
                        </div>
                    </div>
                ))}
            </div>
            <div className="HorizontalBarChart__bars">
                {data.map((item, index) => (
                    <HorizontalBar
                        key={item.id}
                        className={cn(
                            "HorizontalBarChart__row",
                            item.isHidden && "is-hidden",
                            'appears-top',
                            `del-${index}`,
                            'fast',
                        )}
                        maxValue={maxValue}
                        value={item.numValue}
                        label={item.value}
                        color={color}
                        testId={`blockHorizontalBarChartBar${index}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default HorizontalBarChart;